import React, { createContext, useContext, useEffect, useState } from "react";
import Cookies from "js-cookie";

interface UserContextType {
  isLoggedIn: boolean;
  logoutUser: () => void;
  loginUser: () => void;
}

interface Props {
  children: React.ReactNode;
}

export const AuthContext = createContext<UserContextType>(
  {} as UserContextType
);

export const AuthProvider = ({ children }: Props) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = Cookies.get("token");
    setIsLoggedIn(!!token);
  }, []);

  const loginUser = () => setIsLoggedIn(true);
  const logoutUser = () => {
    setIsLoggedIn(false);
    Cookies.remove("token");
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        loginUser,
        logoutUser,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
